import React from 'react';

interface IShowProps {
  when: boolean;
  fallback?: React.JSX.Element | null;
}

const Show = ({
  when,
  children,
  fallback = null,
}: React.PropsWithChildren<IShowProps>) => {
  if (!when) {
    return fallback === null ? null : <>{fallback}</>;
  }

  return <>{children}</>;
};

export { Show };
